// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Cancel from "@material-ui/icons/Cancel";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Layers from "@material-ui/icons/Layers";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import Send from "@material-ui/icons/Send";
import Search from "@material-ui/icons/Search";
import Clear from "@material-ui/icons/Clear";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { infoColor, successColor } from "assets/jss/material-dashboard-pro-react.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import axios from 'axios';
import Badge from "components/Badge/Badge";
import Button from "components/CustomButtons/Button.jsx";
import { TransReactTable } from "components/CustomReactTable/TransReactTable";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Muted from "components/Typography/Muted";
import Success from "components/Typography/Success";
import moment from "moment";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { app_url } from "redux/config";
import { api_url } from 'redux/config.js';
import { CallApi } from 'utils/Request';
import Toast from 'views/Toast/Toast';
import CampaignContent from "./CampaignContent";


const styles = {
  ...regularFormsStyle,
  ...extendedFormsStyle,
  ...sweetAlertStyle,
  checkedStatus: { textAlign: 'center', color: infoColor },
  filterBar: {
    background: '#f5f5f5',
    padding: '15px',
    borderRadius: '6px',
    marginBottom: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    alignItems: 'center'
  },
  filterField: { minWidth: '140px' },
  selectionInfo: {
    padding: '10px 15px',
    background: '#e3f2fd',
    borderRadius: '6px',
    marginBottom: '10px',
    fontSize: '14px'
  }
};

class CampaignDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      campaign_id: this.props.match.params.id,
      campaign_data: null,
      // Filters
      filterFrom: '',
      filterTo: '',
      filterEmail: '',
      // Selection
      selectedEmails: new Set(),
      smsLog: null,          // rows from /user/sms_log for this campaign
      smsFrom: '', smsTo: '', smsSearch: '',
    };
  }

  componentDidMount() {
    this.onLoad();
  }

  loadSmsLog = () => {
    CallApi({ url: 'user/sms_log', method: 'get', params: { campaign_id: this.state.campaign_id } })
      .then(res => { if (res && res.success) this.setState({ smsLog: res.data || [] }); })
      .catch(() => { /* the log is informational; never block the page over it */ });
  }

  // What actually went out per number, with the delivery status the provider reported back.
  renderSmsTab = () => {
    const { t, classes } = this.props;
    const all = this.state.smsLog;
    if (all === null) return <div style={{ padding: 16 }}>{t('Loading…')}</div>;

    // Same date/search narrowing as the e-mail tab, minus the resend controls: a message already
    // paid for is not something to fire again from here.
    const { smsFrom, smsTo, smsSearch } = this.state;
    const rows = (all || []).filter(r => {
      const d = moment(r.created_at);
      if (smsFrom && d.isBefore(moment(smsFrom).startOf('day'))) return false;
      if (smsTo && d.isAfter(moment(smsTo).endOf('day'))) return false;
      if (smsSearch && String(r.phone || '').indexOf(smsSearch.trim()) < 0) return false;
      return true;
    });

    const filterBar = (
      <div className={classes.filterBar}>
        <TextField label={t('From Date')} type="date" value={smsFrom} className={classes.filterField}
          onChange={(e) => this.setState({ smsFrom: e.target.value })} InputLabelProps={{ shrink: true }} />
        <TextField label={t('To Date')} type="date" value={smsTo} className={classes.filterField}
          onChange={(e) => this.setState({ smsTo: e.target.value })} InputLabelProps={{ shrink: true }} />
        <TextField label={t('Search by phone')} value={smsSearch} className={classes.filterField}
          onChange={(e) => this.setState({ smsSearch: e.target.value })} />
        <Button color="default" size="sm" style={{ textTransform: 'none' }}
          onClick={() => this.setState({ smsFrom: '', smsTo: '', smsSearch: '' })}>
          {t('Clear Filters')}
        </Button>
        <span style={{ fontSize: 13, color: '#5d6d66' }}>
          {t('Filtered')}: {rows.length} / {all.length}
        </span>
      </div>
    );

    if (!all.length) {
      return <div style={{ padding: 16, color: '#5d6d66' }}>
        {t('No SMS sent yet for this campaign.')}
      </div>;
    }
    if (!rows.length) {
      return <div>{filterBar}
        <div style={{ padding: 16, color: '#5d6d66' }}>{t('No SMS matches these filters.')}</div>
      </div>;
    }
    const label = {
      delivered: { text: t('Delivered'), color: '#2f8a45', bg: '#e7f4ea' },
      sent: { text: t('Sent'), color: '#245b96', bg: '#e8f1fb' },
      queued: { text: t('Queued'), color: '#8a6d1e', bg: '#fff8e1' },
      failed: { text: t('Failed'), color: '#c0392b', bg: '#fdecea' },
    };
    return (
      <div>
      {filterBar}
      <TransReactTable
        defaultPageSize={20}
        data={rows.map(r => {
          const l = label[r.status] || { text: r.status, color: '#5d6d66', bg: '#eee' };
          return {
            phone: r.phone,
            status: (
              <span style={{
                fontSize: 11.5, fontWeight: 700, padding: '3px 9px', borderRadius: 99,
                background: l.bg, color: l.color, whiteSpace: 'nowrap',
              }}>{l.text}</span>
            ),
            segments: r.segments,
            date: moment(r.created_at).format('MMMM Do YYYY, HH:mm'),
            error: r.error || '',
          };
        })}
        columns={[
          { Header: t('Phone'), accessor: 'phone' },
          { Header: t('Status'), accessor: 'status', sortable: false, maxWidth: 130 },
          { Header: t('SMS segment(s)'), accessor: 'segments', maxWidth: 110 },
          { Header: t('Date'), accessor: 'date' },
          { Header: t('Error'), accessor: 'error' },
        ]}
      />
      </div>
    );
  }

  onLoad = () => {
    let self = this;
    const url = api_url + `campaign/get`;
    const header = 'Bearer '.concat(this.props.user.token);
    const params = { id: this.state.campaign_id };
    const headers = this.props.user.token ? { Authorization: header } : null;

    this.props.dispatch({ type: 'LOAD_START' });
    axios({ url, method: 'get', headers, params })
      .then(function (response) {
        if (response.data.success) {
          self.setState({ campaign_data: response.data.data, selectedEmails: new Set() });
          // A campaign that texts has an SMS log rather than an email one; fetch it so the tab has
          // something to show instead of an empty email table.
          const ch = (response.data.data || {}).send_channel || 'email';
          if (ch === 'sms' || ch === 'both') self.loadSmsLog();
        } else {
          Toast(400, response.data.error);
        }
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) { Toast(500); return; }
        Toast(errors.response.status);
      });
  };

  // Apply filters and return filtered email list
  getFilteredEmails = () => {
    if (!this.state.campaign_data) return [];
    const { filterFrom, filterTo, filterEmail } = this.state;
    const emails = this.state.campaign_data.total_emails_with_isattempt || [];

    return emails.filter(item => {
      // Email search
      if (filterEmail && filterEmail.trim()) {
        const search = filterEmail.trim().toLowerCase();
        if (!item.email.toLowerCase().includes(search)) return false;
      }
      // Date range (based on sent_at)
      if (filterFrom || filterTo) {
        if (!item.sent_at) return false; // if filtering by date, exclude unsent
        const sentDate = moment(item.sent_at);
        if (filterFrom && sentDate.isBefore(moment(filterFrom).startOf('day'))) return false;
        if (filterTo && sentDate.isAfter(moment(filterTo).endOf('day'))) return false;
      }
      return true;
    });
  };

  toggleEmail = (email) => {
    const selected = new Set(this.state.selectedEmails);
    if (selected.has(email)) selected.delete(email);
    else selected.add(email);
    this.setState({ selectedEmails: selected });
  };

  selectAllFiltered = () => {
    const filtered = this.getFilteredEmails();
    // Select only NOT attempted ones (those eligible for resend)
    const eligible = filtered.filter(e => !e.attempted);
    const selected = new Set(this.state.selectedEmails);
    eligible.forEach(e => selected.add(e.email));
    this.setState({ selectedEmails: selected });
  };

  clearSelection = () => {
    this.setState({ selectedEmails: new Set() });
  };

  clearFilters = () => {
    this.setState({ filterFrom: '', filterTo: '', filterEmail: '', selectedEmails: new Set() });
  };

  resendToSelected = () => {
    const emails = Array.from(this.state.selectedEmails);
    if (emails.length === 0) {
      Toast(400, this.props.t('Please select at least one email'));
      return;
    }
    const self = this;
    this.props.dispatch({ type: 'LOAD_START' });
    CallApi({
      url: 'campaign/resend_to_selected',
      method: 'post',
      data: { campaign_id: this.state.campaign_id, emails }
    }).then(res => {
      if (res.success) {
        Toast(200, self.props.t('Emails sent: ') + (res.sent_count || emails.length));
        self.setState({ selectedEmails: new Set() });
        self.onLoad();
      } else {
        Toast(400, res.error);
      }
      self.props.dispatch({ type: 'LOAD_END' });
    }).catch(() => {
      Toast(500);
      self.props.dispatch({ type: 'LOAD_END' });
    });
  };

  geEmailsTableData = () => {
    const { classes, t } = this.props;
    if (!this.state.campaign_data) return [];
    const campaign_data = this.state.campaign_data;
    const filtered = this.getFilteredEmails();

    return filtered.map((item, key) => {
      const isSelected = this.state.selectedEmails.has(item.email);
      const canSelect = !item.attempted; // can only resend to not-attempted

      const checkbox = (
        <Checkbox
          checked={isSelected}
          disabled={!canSelect}
          onChange={() => this.toggleEmail(item.email)}
          color="primary"
        />
      );

      const action = (
        <div key={key}>
          <Button justIcon size="sm" color="info" onClick={() => {
            CallApi({ method: 'GET', url: `/campaign/generate_link?campaign_id=${campaign_data.id}&email=${encodeURIComponent(item.email)}` })
              .then(res => {
                if (res.success) {
                  prompt("Please copy link", `${app_url}/public/campaign_survey/${res.token}`);
                }
              });
          }}>
            <Layers />
          </Button>
          {item.attempted && campaign_data.survey && campaign_data.survey.responses && (
            <Button justIcon size="sm" color="info" onClick={() => {
              const resp = campaign_data.survey.responses.filter(r => r.email === item.email && r.type === 'campaign')[0];
              if (resp) {
                const win = window.open(`/public/survey_answer/${campaign_data.survey.id}/${resp.id}`, '_blank');
                win.focus();
              }
            }}>
              <RemoveRedEye />
            </Button>
          )}
        </div>
      );

      return {
        checkbox,
        email: item.email,
        sent_date: item.sent_at ? moment(item.sent_at).format("DD/MM/YYYY HH:mm") : <Muted>{t('Not sent')}</Muted>,
        responded_date: item.responded_at ? moment(item.responded_at).format("DD/MM/YYYY HH:mm") : '-',
        response_status: (
          <div>
            {item.attempted && <Badge color="success">{t('Attempted')}</Badge>}
            {!item.attempted && item.sent_at && <Badge color="gray">{t('Not answered')}</Badge>}
            {!item.attempted && !item.sent_at && <Badge color="warning">{t('Not sent')}</Badge>}
          </div>
        )
      };
    });
  };

  render() {
    const { classes, t } = this.props;
    const { campaign_data, filterFrom, filterTo, filterEmail, selectedEmails } = this.state;

    if (campaign_data && !campaign_data.survey) {
      this.props.history.replace('/campaign/campaign');
      return null;
    }

    const column = [
      { Header: '', accessor: 'checkbox', sortable: false, width: 50 },
      { Header: t('Email'), accessor: 'email' },
      { Header: t('Sent Date'), accessor: 'sent_date' },
      { Header: t('Response Date'), accessor: 'responded_date' },
      { Header: t('Respondent Status'), accessor: 'response_status' }
    ];

    const filteredEmails = this.getFilteredEmails();
    const filteredNotAttempted = filteredEmails.filter(e => !e.attempted).length;
    const selectedCount = selectedEmails.size;
    const channel = (this.state.campaign_data || {}).send_channel || 'email';

    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem md={12} sm={12}>
            <NavPills
              color="info"
              tabs={[
                // An SMS-only campaign has no email tracking to show — its recipients are numbers.
                // Swapping the tab keeps the page honest instead of presenting an empty email table
                // and a "0 filtered" bar that suggests something went wrong.
                ...(channel === 'sms' ? [{
                  tabButton: 'SMS',
                  tabContent: this.renderSmsTab(),
                }] : []),
                ...(channel === 'email' || channel === 'both' ? [{
                  tabButton: t("E-mails"),
                  tabContent: (
                    <div>
                      {/* Filter Bar */}
                      <div className={classes.filterBar}>
                        <TextField
                          label={t('From Date')}
                          type="date"
                          value={filterFrom}
                          onChange={(e) => this.setState({ filterFrom: e.target.value })}
                          InputLabelProps={{ shrink: true }}
                          className={classes.filterField}
                        />
                        <TextField
                          label={t('To Date')}
                          type="date"
                          value={filterTo}
                          onChange={(e) => this.setState({ filterTo: e.target.value })}
                          InputLabelProps={{ shrink: true }}
                          className={classes.filterField}
                        />
                        <TextField
                          label={t('Search by email')}
                          type="text"
                          value={filterEmail}
                          onChange={(e) => this.setState({ filterEmail: e.target.value })}
                          placeholder={t('email contains...')}
                          style={{ minWidth: '220px' }}
                        />
                        <Button color="default" size="sm" style={{ textTransform: "none" }} onClick={this.clearFilters}>
                          <Clear /> {t('Clear Filters')}
                        </Button>
                      </div>

                      {/* Selection & Action Bar */}
                      <div className={classes.selectionInfo}>
                        <strong>{t('Filtered')}: {filteredEmails.length}</strong>
                        {' | '}
                        <span>{t('Not yet answered')}: {filteredNotAttempted}</span>
                        {' | '}
                        <strong style={{ color: selectedCount > 0 ? successColor : '#666' }}>
                          {t('Selected')}: {selectedCount}
                        </strong>
                      </div>

                      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                        <Button color="info" size="sm" style={{ textTransform: "none" }} onClick={this.selectAllFiltered} disabled={filteredNotAttempted === 0}>
                          {t('Select All Filtered (Not Answered)')}
                        </Button>
                        <Button color="default" size="sm" style={{ textTransform: "none" }} onClick={this.clearSelection} disabled={selectedCount === 0}>
                          {t('Clear Selection')}
                        </Button>
                        <Button color="success" size="sm" style={{ textTransform: "none" }} onClick={this.resendToSelected} disabled={selectedCount === 0}>
                          <Send /> {t('Resend to Selected')} ({selectedCount})
                        </Button>
                      </div>

                      <TransReactTable
                        defaultPageSize={20}
                        data={this.geEmailsTableData()}
                        columns={column}
                      />
                    </div>
                  )
                }] : []),
                {
                  tabButton: t("Campaign"),
                  tabContent: <CampaignContent campaign_data={this.state.campaign_data} />
                }
              ]}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(CampaignDetailPage)));
